<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8,4C11.31,4,14,3.1,14,2C14,0.9,11.31,0,8,0C4.68,0,2,0.9,2,2C2,3.1,4.68,4,8,4C8,4,8,4,8,4ZM2,3.52C2,3.52,2,8,2,8C2,9.1,4.6899999999999995,10,8,10C11.31,10,14,9.1,14,8C14,8,14,3.52,14,3.52C12.78,4.4,10.56,5,8,5C5.4399999999999995,5,3.2199999999999998,4.4,2,3.52C2,3.52,2,3.52,2,3.52ZM2,9.52C2,9.52,2,14,2,14C2,15.1,4.6899999999999995,16,8,16C11.31,16,14,15.1,14,14C14,14,14,9.52,14,9.52C12.78,10.4,10.56,11,8,11C5.4399999999999995,11,3.2199999999999998,10.4,2,9.52C2,9.52,2,9.52,2,9.52Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Database',
} as DefineComponent
</script>
